import { GiveUpModalActionType } from '../../types/giveUpModalType'

export const closeGiveUpModal = () => {
    return {type: GiveUpModalActionType.CLOSE_GIVE_UP_MODAL}
}

export const openGiveUpModal = () => {
    return {type: GiveUpModalActionType.OPEN_GIVE_UP_MODAL}
}